import { 
  Home, 
  Sofa, 
  DoorOpen, 
  TreeDeciduous, 
  Wrench, 
  PencilRuler 
} from "lucide-react";

const ServicesSection = () => {
  const services = [
    {
      icon: PencilRuler,
      title: "Menuiserie sur Mesure",
      description:
        "Conception et fabrication de pièces uniques adaptées à vos espaces et vos envies. Du plan à la réalisation.",
    },
    {
      icon: Sofa,
      title: "Mobilier sur Mesure",
      description:
        "Création de meubles personnalisés : bibliothèques, dressings, placards, tables et rangements.",
    },
    {
      icon: Home,
      title: "Aménagement Intérieur",
      description:
        "Transformation de vos espaces : parquets, lambris, cuisines et salles de bain.",
    },
    {
      icon: TreeDeciduous,
      title: "Terrasses & Extérieurs",
      description:
        "Conception de terrasses bois, pergolas, carports et aménagements extérieurs durables.",
    },
    {
      icon: Wrench,
      title: "Restauration & Rénovation",
      description:
        "Redonnez vie à vos menuiseries anciennes. Restauration de meubles de caractère.",
    },
  ];

  return (
    <section
      id="services"
      className="py-20 md:py-32 bg-white relative"
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-forest-green font-medium text-sm uppercase tracking-wider">
            Nos Services
          </span>
          <h2 
            className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-deep-oak mt-3 mb-6"
            data-testid="services-title"
          >
            Un Savoir-Faire Complet
          </h2>
          <p className="text-text-secondary text-base md:text-lg">
            De la conception à la pose, nous vous accompagnons dans tous vos 
            projets de menuiserie. Chaque réalisation est le fruit d'un travail 
            minutieux et passionné.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="service-card bg-warm-cream rounded-xl p-8 card-hover border border-transparent hover:border-deep-oak/10"
              data-testid={`service-card-${index}`}
            >
              <div className="service-icon">
                <service.icon className="w-7 h-7" />
              </div>
              <h3 className="font-heading text-xl font-semibold text-deep-oak mb-3">
                {service.title}
              </h3>
              <p className="text-text-secondary text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <p className="text-text-secondary mb-6">
            Vous avez un projet spécifique ? Parlons-en ensemble.
          </p>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="btn-primary inline-flex"
            data-testid="services-cta"
          >
            Discuter de votre projet
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
